import React from "react";
import styled from "styled-components";

import { SortingOption } from "../types";

import { SortingOptionButton } from "../AvailablePositions.styles";

// T2-6193: the "Date Posted" / sort popup previously used PopupContainerBase,
// which has no max-width, so inside the legacy full-screen <Popup> it stretched
// edge-to-edge. Mirror the sibling Filter popup's compact container (T2-6046):
// constrained to max-width 480px, centered, padding/radius/shadow — so it reads
// as a standard modal instead of a full-screen sheet.
const CompactSortingContainer = styled.div`
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 0.5rem 0;
  border-radius: 12px;
  background: white;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
  box-sizing: border-box;
`

interface SortingOptionsProps {
  onOptionSelect: (option: SortingOption) => void
}

const SortingOptions = ({onOptionSelect}: SortingOptionsProps) => {
  return (
    <CompactSortingContainer>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.datePosted)} className='no-fastclick'>
        {SortingOption.datePosted}
      </SortingOptionButton>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.startDate)} className='no-fastclick'>
        {SortingOption.startDate}
      </SortingOptionButton>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.distance)} className='no-fastclick'>
        {SortingOption.distance}
      </SortingOptionButton>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.applied)} className='no-fastclick'>
        {SortingOption.applied}
      </SortingOptionButton>
    </CompactSortingContainer>
  );
}

export default SortingOptions;
